import React, { useState } from 'react'
import { Link } from 'gatsby'
import MediaQuery from 'react-responsive'
import { useSelector } from 'react-redux'
import GeneralNavigation from './GeneralNavigation'
import Img from '../general/Image'
import useContent from '../../utils/content'
import { useNavigationQuery } from '../../hooks/useNavigationQuery'

function NavigationMobile() {
  const [displayMenu, setDisplayMenu] = useState(false)

  const showDropdownMenu = () => {
    !displayMenu ? setDisplayMenu(true) : setDisplayMenu(false)
  }

  const state = useSelector(props => props)
  const content = useContent(useNavigationQuery())

  return (
    <>
      <MediaQuery maxDeviceWidth={768.97}>
        <header className={`header header--${displayMenu ? 'menu' : null}`}>
          <div className="container">
            <nav className="navigation">
              <Link
                to={`/${
                  state.languageValue === 'uk' ? '' : state.languageValue
                }`}
                className="navigation_logo"
              >
                <Img src={content.logo} className="navigation_logo_img" />
              </Link>
              <GeneralNavigation displayMenu={displayMenu} />
              <div
                className="burger"
                onClick={showDropdownMenu}
                onKeyDown={showDropdownMenu}
                role="button"
                tabIndex="0"
              >
                <span />
                <span />
                <span />
                <span />
              </div>
            </nav>
          </div>
        </header>
      </MediaQuery>
    </>
  )
}

export default NavigationMobile
